import React from 'react';
import WizardInputSkeleton from 'components/v2/epd-wizard-inputs/WizardInputSkeleton';
import { Skeleton } from 'primereact/skeleton';
import { FieldPanel } from 'styles/v2/Styles.styled';

const AdminEditToolHeadSkeleton: React.FC = () => {
  return (
    <div>
      <FieldPanel style={{ marginTop: 60, alignItems: 'flex-start' }}>
        <Skeleton width="20em" />
        <div className="w-full">
          <WizardInputSkeleton />
        </div>
        {Array(8)
          .fill(0)
          .map((_, i) => (
            <WizardInputSkeleton key={i} />
          ))}
      </FieldPanel>
    </div>
  );
};

export default AdminEditToolHeadSkeleton;
